'use strict';

module.exports = require('./makeMakeHot');


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-hot-api/modules/index.js
 ** module id = 35
 ** module chunks = 0
 **/